import script from "./Personnel.vue?vue&type=script&setup=true&lang=js"
export * from "./Personnel.vue?vue&type=script&setup=true&lang=js"

import "./Personnel.vue?vue&type=style&index=0&id=389fe4ae&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-389fe4ae"]])

export default __exports__